import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './public/login/login.component';
import {PaymentComponent} from './payment/payment.component';
import {DashboardLayoutComponent} from './dashboard/dashboard-layout/dashboard-layout.component';
import {PaymentScreenComponent} from './payment/payment-screen/payment-screen.component';
import {ApprovalProcessComponent} from './approval-process/approval-process.component';
import {ApprovalPendingListComponent} from './approval-process/approval-pending-list/approval-pending-list.component';
import {ApprovalProcessRequestViewerComponent} from './approval-process/approval-process-request-viewer/approval-process-request-viewer.component';
import {DispatchProcessComponent} from './dispatch-process/dispatch-process.component';
import {ScanPendingListComponent} from './dispatch-process/scan-pending-list/scan-pending-list.component';
import {BlacklistProcessComponent} from './blacklist-process/blacklist-process.component';
import {BlacklistProcessRequestViewerComponent} from './blacklist-process/blacklist-process-request-viewer/blacklist-process-request-viewer.component';
import {BlacklistProcessVerificationComponent} from './blacklist-process/blacklist-process-verification/blacklist-process-verification.component';
import {BlacklistVerificationRequestViewerComponent} from './blacklist-process/blacklist-process-verification/blacklist-verification-request-viewer/blacklist-verification-request-viewer.component';
import {BlacklistProcessAuthorizationComponent} from './blacklist-process/blacklist-process-authorization/blacklist-process-authorization.component';
import {BlacklistAuthorizationRequestViewerComponent} from './blacklist-process/blacklist-process-authorization/blacklist-authorization-request-viewer/blacklist-authorization-request-viewer.component';
import {ReturnRequestViewerComponent} from './blacklist-process/blacklist-process-request-viewer/return-request-details/return-request-viewer/return-request-viewer.component';
import {BlacklistReturnRequestComponent} from './blacklist-process/blacklist-process-request-viewer/return-request-details/blacklist-return-request/blacklist-return-request.component';
import {ReturnBlacklistRequestDetailsComponent} from './blacklist-process/blacklist-process-authorization/blacklist-authorization-request-viewer/return-blacklist-request-details/return-blacklist-request-details.component';
import {BlacklistReturnRequestViewerComponent} from './blacklist-process/blacklist-process-verification/blacklist-return-request-viewer/blacklist-return-request-viewer.component';
import {ScanPendingDataComponent} from './dispatch-process/scan-pending-list/scan-pending-data/scan-pending-data.component';
import {CardDispatchComponent} from './dispatch-process/card-dispatch/card-dispatch.component';
import {ManualDispatchComponent} from './dispatch-process/card-dispatch/manual-dispatch/manual-dispatch.component';
import {ReversedProcessVerificationComponent} from './reversed-blacklist-process/reversed-process-verification/reversed-process-verification.component';
import {ReversedBlacklistProcessComponent} from './reversed-blacklist-process/reversed-blacklist-process.component';
import {ReversedProcessRequestViewerComponent} from './reversed-blacklist-process/reversed-process-request-viewer/reversed-process-request-viewer.component';
import {ReversedProcessAuthorizationComponent} from './reversed-blacklist-process/reversed-process-authorization/reversed-process-authorization.component';
import {ReversedBlacklistReturnRequestComponent} from './reversed-blacklist-process/reversed-process-request-viewer/reversed-return-request-details/reversed-blacklist-return-request/reversed-blacklist-return-request.component';
import {ReversedReturnRequestViewerComponent} from './reversed-blacklist-process/reversed-process-request-viewer/reversed-return-request-details/reversed-return-request-viewer/reversed-return-request-viewer.component';
import {ReversedReturnBlacklistRequestDetailsComponent} from './reversed-blacklist-process/reversed-process-authorization/reversed-blacklist-authorization-request-viewer/reversed-return-blacklist-request-details/reversed-return-blacklist-request-details.component';
import {ReversedBlacklistVerificationRequestViewerComponent} from './reversed-blacklist-process/reversed-process-verification/reversed-blacklist-verification-request-viewer/reversed-blacklist-verification-request-viewer.component';
import {ReversedBlacklistAuthorizationRequestViewerComponent} from './reversed-blacklist-process/reversed-process-authorization/reversed-blacklist-authorization-request-viewer/reversed-blacklist-authorization-request-viewer.component';
import {ReversedBlacklistReturnRequestViewerComponent} from './reversed-blacklist-process/reversed-process-verification/reversed-blacklist-return-request-viewer/reversed-blacklist-return-request-viewer.component';
import {SuspendProcessComponent} from './suspend-process/suspend-process.component';
import {SuspendReturnRequestComponent} from './suspend-process/suspend-return-request/suspend-return-request.component';
import {SuspendProcessVerificationComponent} from './suspend-process/suspend-process-verification/suspend-process-verification.component';
import {SuspendVerificationRequestViewerComponent} from './suspend-process/suspend-process-verification/suspend-verification-request-viewer/suspend-verification-request-viewer.component';
import {SuspendProcessAuthorizationComponent} from './suspend-process/suspend-process-authorization/suspend-process-authorization.component';
import {SuspendAuthorizationRequestViewerComponent} from './suspend-process/suspend-process-authorization/suspend-authorization-request-viewer/suspend-authorization-request-viewer.component';
import {ReversedSuspendProcessComponent} from './reversed-suspend-process/reversed-suspend-process.component';
import {ReversedSuspendRequestViewerComponent} from './reversed-suspend-process/reversed-suspend-request-viewer/reversed-suspend-request-viewer.component';
import {ReversedSuspendVerification} from './reversed-suspend-process/reversed-suspend-verification/reversed-suspend-verification.component';
import {ReversedSuspendVerificationRequestViewerComponent} from './reversed-suspend-process/reversed-suspend-verification/reversed-suspend-verification-request-viewer/reversed-suspend-verification-request-viewer.component';
import {DashHomeComponent} from './dashboard/dash-home/dash-home.component';
import {ReversedSuspendAuthorizationComponent} from './reversed-suspend-process/reversed-suspend-authorization/reversed-suspend-authorization.component';
import {ReversedSuspendAuthorizationRequestViewerComponent} from './reversed-suspend-process/reversed-suspend-authorization/reversed-suspend-authorization-request-viewer/reversed-suspend-authorization-request-viewer.component';
import {ReversedSuspendReturnRequestViewerComponent} from './reversed-suspend-process/reversed-suspend-return-request-viewer/reversed-suspend-return-request-viewer.component';
import {ReversedSuspendReturnRequestsComponent} from './reversed-suspend-process/reversed-suspend-return-requests/reversed-suspend-return-requests.component';
import {ReversedSuspendBlacklistComponent} from './reversed-suspend-blacklist/reversed-suspend-blacklist.component';
import {ReversedSuspendBlacklistRequestViewerComponent} from './reversed-suspend-blacklist/reversed-suspend-blacklist-request-viewer/reversed-suspend-blacklist-request-viewer.component';
import {ReversedSuspendBlacklistVerificationViewerComponent} from './reversed-suspend-blacklist/reversed-suspend-blacklist-verification/reversed-suspend-blacklist-verification-viewer/reversed-suspend-blacklist-verification-viewer.component';
import {ReversedSuspendBlacklistVerificationComponent} from './reversed-suspend-blacklist/reversed-suspend-blacklist-verification/reversed-suspend-blacklist-verification.component';
import {ReversedSupendBlacklistAuthorizationComponent} from './reversed-suspend-blacklist/reversed-supend-blacklist-authorization/reversed-supend-blacklist-authorization.component';
import {ReversedSuspBlackAuthRequestViewerComponent} from './reversed-suspend-blacklist/reversed-supend-blacklist-authorization/reversed-supend-blacklist-authorization-request-viewer/reversed-susp-black-auth-request-viewer.component';
import {ReversedSuspendBlacklistReturnRequestViewerComponent} from './reversed-suspend-blacklist/reversed-suspend-blacklist-return-request-viewer/reversed-suspend-blacklist-return-request-viewer.component';
import {ReversedSuspendBlacklistReturnComponent} from './reversed-suspend-blacklist/reversed-suspend-blacklist-return/reversed-suspend-blacklist-return.component';
import {SuspendBlacklistVerificationComponent} from './suspend-blacklist-process/suspend-blacklist-process-viewer/suspend-blacklist-verification/suspend-blacklist-verification.component';
import {SuspendBlacklistProcessViewerComponent} from './suspend-blacklist-process/suspend-blacklist-process-viewer/suspend-blacklist-process-viewer.component';
import {SuspendBlacklistAuthorizationComponent} from './suspend-blacklist-process/suspend-blacklist-authorization/suspend-blacklist-authorization.component';
import {SuspendBlacklistAuthorizationViewerComponent} from './suspend-blacklist-process/suspend-blacklist-authorization/suspend-blacklist-authorization-viewer/suspend-blacklist-authorization-viewer.component';
import {SuspendBlacklistReturnDataComponent} from './suspend-blacklist-process/suspend-blacklist-return-data/suspend-blacklist-return-data.component';
import {SuspendBlacklistRerurnViewerComponent} from './suspend-blacklist-process/suspend-blacklist-return-data/suspend-blacklist-rerurn-viewer/suspend-blacklist-rerurn-viewer.component';
import {SuspendBlacklistReturnRequestsComponent} from './suspend-blacklist-process/suspend-blacklist-process-viewer/suspend-blacklist-return-requests/suspend-blacklist-return-requests.component';
import {AdminDashboardComponent} from './dashboard/admin-dashboard/admin-dashboard.component';

const routes: Routes = [
  {path: '', component: LoginComponent, data: {title: 'Login'}},
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'payment/:type',
        component: PaymentComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'payment',
        component: PaymentComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'app-payment/:refNo',
        component: PaymentScreenComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'dashHome',
        component: ApprovalProcessComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'adminDashboard',
        component: AdminDashboardComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'approval/:type',
        component: DashHomeComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'approval',
        component: DashHomeComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist/:type',
        component: BlacklistProcessComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist/:type',
        component: ReversedBlacklistProcessComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist',
        component: ReversedSuspendBlacklistComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklists/:type',
        component: ReversedSuspendBlacklistComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-data/:id',
        component: ReversedSuspendBlacklistRequestViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-verification',
        component: ReversedSuspendBlacklistVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-verifications/:type',
        component: ReversedSuspendBlacklistVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-verification/:id',
        component: ReversedSuspendBlacklistVerificationViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-authorization',
        component: ReversedSupendBlacklistAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-authorizations/:type',
        component: ReversedSupendBlacklistAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-authorization/:id',
        component: ReversedSuspBlackAuthRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-return-data',
        component:  ReversedSuspendBlacklistReturnRequestViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-return-datas/:type',
        component:  ReversedSuspendBlacklistReturnRequestViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-blacklist-return-data/:id',
        component: ReversedSuspendBlacklistReturnComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend',
        component: ReversedSuspendProcessComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend/:type',
        component: ReversedSuspendProcessComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-verification',
        component: ReversedSuspendVerification
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-verifications/:type',
        component: ReversedSuspendVerification
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-data/:id',
        component: ReversedSuspendRequestViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-verification',
        component: BlacklistProcessVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-blacklist-verification',
        component: SuspendBlacklistProcessViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-blacklist-verifications/:type',
        component: SuspendBlacklistProcessViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-blacklist-verification/:id',
        component: SuspendBlacklistVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-verifications/:type',
        component: BlacklistProcessVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-verification',
        component: SuspendProcessVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-verifications/:type',
        component: SuspendProcessVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-verification/:type',
        component: ReversedProcessVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-verifications/:type',
        component: ReversedProcessVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-verification',
        component: ReversedProcessVerificationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-authorization/:type',
        component: BlacklistProcessAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-blacklist-authorization',
        component: SuspendBlacklistAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-blacklist-authorizations/:type',
        component: SuspendBlacklistAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-authorizations/:type',
        component: BlacklistProcessAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-authorization',
        component: SuspendProcessAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-authorizations/:type',
        component: SuspendProcessAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-authorization',
        component: ReversedProcessAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-authorizations/:type',
        component: ReversedProcessAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-authorization',
        component: ReversedSuspendAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-authorizations/:type',
        component: ReversedSuspendAuthorizationComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'approval-pending/:type',
        component: ApprovalPendingListComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'approval-pending-data/:id/:type',
        component: ApprovalProcessRequestViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-data/:id/:types',
        component: BlacklistProcessRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-data/:id',
        component: ReversedBlacklistReturnRequestComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-return-data/:id',
        component: BlacklistReturnRequestComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-return-data/:id/:stage',
        component: BlacklistReturnRequestComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-return-data/:id',
        component: SuspendReturnRequestComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-return-data/:id/:type',
        component: ReversedSuspendReturnRequestsComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-return-data/:id',
        component: ReversedProcessRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-return-data',
        component:  ReturnRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-blacklist-return-data',
        component:  SuspendBlacklistReturnRequestsComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-blacklist-return-data/:type',
        component:  SuspendBlacklistReturnRequestsComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-return-datas/:type',
        component:  ReturnRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-return-data',
        component:  SuspendProcessComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-return/:type',
        component:  SuspendProcessComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-return-data',
        component:  ReversedSuspendReturnRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-return-datas/:type',
        component:  ReversedSuspendReturnRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-return-data',
        component:  ReversedReturnRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-return-datas/:type',
        component:  ReversedReturnRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'return-request-data/:type',
        component:  ReturnBlacklistRequestDetailsComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-return-request-data',
        component:  SuspendBlacklistReturnDataComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-return-request-data/:type',
        component:  SuspendBlacklistReturnDataComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'return-request-data/:type',
        component:  ReturnBlacklistRequestDetailsComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-return-request-data',
        component:  ReversedReturnBlacklistRequestDetailsComponent
      },
    ],
  },


  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-return-request-data/:type',
        component:  ReversedReturnBlacklistRequestDetailsComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-verification/:id/:type',
        component: BlacklistVerificationRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-verification/:id/:type',
        component: SuspendVerificationRequestViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-verification/:id/:type',
        component: ReversedSuspendVerificationRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-verification/:id/:type',
        component: ReversedBlacklistVerificationRequestViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-authorization/:id/:type',
        component: BlacklistAuthorizationRequestViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-blacklist-authorization/:id',
        component: SuspendBlacklistAuthorizationViewerComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-authorization/:id/:type',
        component: SuspendAuthorizationRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-authorization/:id/:type',
        component: ReversedBlacklistAuthorizationRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-suspend-authorization/:id/:type',
        component: ReversedSuspendAuthorizationRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'blacklist-return/:id/:type',
        component: BlacklistReturnRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'suspend-blacklist-return/:id',
        component: SuspendBlacklistRerurnViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'reversed-blacklist-return/:id',
        component: ReversedBlacklistReturnRequestViewerComponent
      },
    ],
  },

  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'scan',
        component: DispatchProcessComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'scan-pending/:type',
        component: ScanPendingListComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'scan-pending-data/:sid/:type',
        component: ScanPendingDataComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'dispatch',
        component: CardDispatchComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'dispatch/:type',
        component: CardDispatchComponent
      },
    ],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'manula-dispatch/:sid/:appRefNo/:type',
        component: ManualDispatchComponent
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
